<template>
<div>
  <querytitle>
    <template slot="queryleft">
      <div style="padding-right:20px;"><span style="color:red;font-size:15px;font-weight: bold;">{{SFT.TNAME}}</span></div>
      <div style="text-align:left;"><span style="color:#000"></span><span>{{SFT.TDESC}}</span></div>
    </template>
    <template slot="queryright">
      <filedialogbutton :par="pars" :TNAME='SFT.TNAME' :okupload="getlist"></filedialogbutton>
    </template>
  </querytitle>
  <div>
    <el-tabs type="card" :style="'height:' + hh + 'px;overflow:auto;padding:1px;border: 1px solid #EBEEF5;'" v-model="currenttab">
      <el-tab-pane :label="item.FILENAME" :name="item.FID" v-for="(item, index) in itemlist" :key="index">
        <fileview :item="item" :hh="hh2" :showbar="true">
          <template slot="editbar">
            <el-button type="text" @click="edit(item,index)" style="color: green" icon="el-icon-edit">修改文件名称</el-button>
            <el-button type="text" @click="del(item, index)" style="color: red" icon="el-icon-close">删除当前文件</el-button>
          </template>
        </fileview>
      </el-tab-pane>
    </el-tabs>
  </div>
  <el-dialog title="修改文件名称" :visible="dialogFormVisible" :show-close="false">
    <el-form label-width="80px">
      <el-form-item label="文件名:"><el-input v-model="currentitem.FILENAME"></el-input></el-form-item>
      <el-form-item label="排序号:"><el-input-number v-model="currentitem.FOID"></el-input-number></el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="postedit()">确 定</el-button>
    </div>
  </el-dialog>
  <sftsumit :SFT="SFT" ref="sftsummit" :chkdata="chkdata"></sftsumit>
</div>
</template>

<script>
import querytitle from '@/components/querytitle'
import sftsumit from '@/components/sftsumit'
import fileview from '@/components/fileview'
import filedialogbutton from '@/components/filedialogbutton'
export default {
  components: {
    querytitle,
    sftsumit,
    fileview,
    filedialogbutton
  },
  data() {
    return {
      SFT: null,
      loading: false,
      itemlist: [],
      currenttab:"",
      hh: 500,
      hh2:450,
      // YY: "2021",
      currentTID: "",
      pars:{},
      dialogFormVisible:false,
      currentitem:{},
      currentindex:0,
    }
  },
  watch: {
    '$route'(to, from) { //监听路由是否变化
      if (to.params.SFT != from.params.SFT) { //pid不为空才请求数据
        //Object.assign(this.SFT,to.params.SFT)
        this.init()
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.itemlist = []
      //let sft = this.GetSFT()
      this.SFT = this.GetSFT() //Object.assign({},sft)
      this.hh = document.documentElement.clientHeight - 250;
      this.hh2 = this.hh -50;
      // this.YY = this.SFT.YY;
      this.currentTID = this.SFT.TID
      this.getlist();
      this.pars = {
        objname: "sys_files",
        TID: this.currentTID,
        ZJS:this.SFT.TNAME.split(',')
      }
    },
    edit(par,index) {
      const that = this;
      that.currentitem =  Object.assign({}, par);
      that.currentindex = index
      that.dialogFormVisible = true;

      // this.$prompt("文件名称", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     inputPattern: /'*/,
      //     inputPlaceholder: "请输入文件名称",
      //     inputValue: par.FILENAME,
      //     inputErrorMessage: "请输入文件名称",
      //   })
      //   .then(({
      //     value
      //   }) => {
      //     let pars = {
      //       objname: "sys_files",
      //       model: {
      //         FID: par.FID,
      //         FILENAME: value
      //       },
      //     };
      //     that.PostData(
      //       "Common/EDIT",
      //       pars,
      //       function (res) {
      //         if (res.data.error_code != 0) {
      //           that.$alert(res.data.message, {
      //             title: "错误"
      //           });
      //           return;
      //         }
      //         par.FILENAME = value;
      //         
      //       },
      //       function (err) {
      //         console.log(err);
      //       }
      //     );
      //   })
      //   .catch(() => {});
    },
    postedit(){
      let that = this
      let pars = {
            objname: "sys_files",
            model: {
              FID: that.currentitem.FID,
              FILENAME: that.currentitem.FILENAME,
              FOID:that.currentitem.FOID
            },
          };
          that.PostData(
            "Common/EDIT",
            pars,
            function (res) {
              if (res.data.error_code != 0) {
                that.$alert(res.data.message, {
                  title: "错误"
                });
                return;
              }
              // par.FILENAME = value;
              that.$set(that.itemlist, that.currentindex, that.currentitem);
              that.dialogFormVisible = false;
            },
            function (err) {
              console.log(err);
            }
          );
    },
    del(item, index) {
      const that = this;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let pars = {
            objname: "sys_files",
            model: {
              FID: item.FID,
              FILEPATH: item.FILEPATH
            },
          };
          that.PostData(
            "Common/DEL",
            pars,
            function (res) {
              if (res.data.error_code != 0) {
                that.$alert(res.data.message, {
                  title: "错误"
                });
                return;
              }
              that.itemlist.splice(index, 1);
              if(that.itemlist.length>0){
                that.currenttab = that.itemlist[0].FID
              }else{
                that.currenttab=""
              }

            },
            function (err) {
              console.log(err);
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getlist() {
      const that = this;
      let pars = {
        objname: "sys_files",
        wheres: [{
          field: "TID",
          sym: "=",
          val: that.SFT.TID,
          oper: "and"
        }, {
          field: "SID",
          sym: "=",
          val: that.CU.cu.sid,
          oper: ""
        }],
        PageSize:100,
        CurrentPage:1,
      };
      that.PostData(
        "Common/GETLIST",
        pars,
        function (res) {
          that.itemlist = res.data.data;
          if(that.itemlist.length>0){
            that.currenttab = that.itemlist[0].FID
          }
        },
        function (err) {
          that.$alert(err, {
            title: "错误"
          });
        }
      );
    },
    chkdata(callback, errback) {
      if (this.itemlist.length < 1) {
        errback('未发现您上传了文件')
      } else {
        callback("")
      }
    }
  }
}
</script>

<style>
</style>
